import { ReactElement } from "react";

import { AccordionPanel } from "@justworkshr/milo-core";
import {
  INTERNATIONAL_CONTRACTORS_PRODUCT_HELP_LINK,
  JUSTWORKS_EOR_HELP_ARTICLE_LINK,
} from "../../constants";
import styles from "../../InternationalSolutionsPage.module.css";

export const Faq = (): ReactElement => {
  const { faqLeftAlign } = styles;
  return (
    <div>
      <AccordionPanel isOpen title="How many countries does Justworks support?">
        <p>
          You can pay contractors in 60+ countries—with many more coming soon.{" "}
          <a href={INTERNATIONAL_CONTRACTORS_PRODUCT_HELP_LINK} target="_blank">
            See a full list of supported countries
          </a>
        </p>
      </AccordionPanel>
      <AccordionPanel
        isOpen
        title={
          <span className={faqLeftAlign}>
            What if I need to pay an international employee instead of a
            contractor?
          </span>
        }
      >
        <p>
          We’ve got you covered!{" "}
          <a href={JUSTWORKS_EOR_HELP_ARTICLE_LINK} target="_blank">
            Our Employer of Record (EOR)
          </a>{" "}
          solution enables you to hire, pay, and provide localized benefits to
          full-time employees in key markets—all without opening a local entity.
          Connect with our team to explore which solution is the right fit for
          your global workforce.
        </p>
      </AccordionPanel>
      <AccordionPanel
        isOpen
        title="Are these payments considered a wire transfer?"
      >
        <p>
          Most international contractor payments on Justworks are not processed
          as traditional wire transfers, but it depends on whether the
          contractor is being paid in USD or their local currency, as well as
          the country they are in. You'll always see the exchange rate and
          delivery estimate during payment setup, giving you transparency and
          peace of mind every step of the way.
        </p>
      </AccordionPanel>
      <AccordionPanel
        isOpen
        title={
          <span className={faqLeftAlign}>
            How long does it take for a payment to appear in a contractor’s bank
            account?
          </span>
        }
      >
        <p>
          Depending on the country, payments take between 5–7 business days to
          land in the recipient’s bank account.
        </p>
      </AccordionPanel>
      <AccordionPanel isOpen title="What about taxes?">
        <p>
          Justworks does not withhold taxes for international contractor
          payments. We also do not provide year-end tax documents for
          international contractors. For businesses that want to ensure proper
          tax withholding and documentation, hiring through our EOR solution may
          be a better fit. We also recommend consulting your legal counsel to
          ensure compliance with local requirements.
        </p>
      </AccordionPanel>
    </div>
  );
};
